import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormGroup, UntypedFormBuilder} from "@angular/forms";
import {map, startWith} from "rxjs/operators";
import * as moment from "moment";

@Component({
  selector: 'app-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss']
})
export class DateFilterComponent implements OnInit, OnChanges {
  @Output() public dateFilter: EventEmitter<{ start: string, end: string }> = new EventEmitter<{ start: string, end: string }>();
  @Input() public customDateRange: any = {};

  public dateRangeForm: FormGroup = this.fb.group({
    day: ['1'],
    start: [moment().subtract(1, 'day')],
    end: [moment()]
  });

  constructor(private fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.subscribeEmitters();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.customDateRange.firstChange) {
      let {from, to} = changes.customDateRange.currentValue;
      this.dateRangeForm.patchValue({start: from, end: to})
      this.dateRangeForm.patchValue({day: 0}, {emitEvent: false});
    }
  }

  public changeEndPickerDate(): void {
    this.dateRangeForm.patchValue({day: null}, {emitEvent: false})
  }

  private subscribeEmitters(): void {

    this.dateRangeForm.get('day')?.valueChanges.subscribe((value: number) => {
      this.dateRangeForm.patchValue({
        start: moment().subtract(value, 'days'),
        end: moment()
      }, {emitEvent: false});
    })

    this.dateRangeForm.valueChanges
      .pipe(
        startWith(this.dateRangeForm.value),
        map((dateRangeForm: { day: number, start: Date, end: Date }) => ({
          start: moment(dateRangeForm.start).toISOString(),
          end: moment(dateRangeForm.end).toISOString()
        })),
      )
      .subscribe((dateRange: { start: string, end: string }) => {
        this.dateFilter.emit(dateRange);
      })
  }
}
